import { services } from "onearm";
import { SubGameState } from "./game/states/SubGameState";
import { GameStates } from "onearm";

export class BuyFreeSpinsState extends SubGameState {
    async enter() {
        super.enter();

        this.bets = services.get("bets");

        this.hud.setBuyBonusState();
        this.addSignalHandler(this.hud.onPressConfirmationOk, this.handlePressOk);
        this.addSignalHandler(this.hud.onPressConfirmationCancel, this.handlePressCancel);
        this.addSignalHandler(this.hud.onPressTotalBetPlus, this.handlePressPlus);
        this.addSignalHandler(this.hud.onPressTotalBetMinus, this.handlePressMinus);
        this.selectedItemIndex = 0;

        this.selectItem(0);
    }

    handlePressOk() {
        this.buyFreeSpins(this.gameLogic.bet, this.selectedItemIndex);
    }

    handlePressCancel() {
        this.owner.goTo(GameStates.IDLE);
    }

    selectItem(index) {
        this.selectedItemIndex = index;

        const item = this.gameLogic.getBuyBonusItems()[index];

        this.hud.setFreeSpins(item.number.spins);
        this.hud.setSelectedPrice(item.price);
    }

    handlePressMinus() {
        this.bets.previousBet();
    }

    handlePressPlus() {
        this.bets.nextBet();
    }

    async buyFreeSpins(bet, freeSpinsCount) {
        try {
            // update balance on UI
            const result = await this.gameLogic.buyFreeSpins(bet, freeSpinsCount);
            this.hud.setBalance(this.gameLogic.balance);
            this.hud.hideBuyBonusPopup();
            this.hud.setSpinState();
            this.hud.setSpinningState();

            if (result.error) {
                // show error on UI and update balance on UI
                this.owner.goTo(GameStates.ERROR, result.error);
                return { error: result.error };
            }

            this.gameState.goTo(GameStates.SPINNING, { result, disableSkip: true });
        } catch (error) {
            this.owner.goTo(GameStates.ERROR, error);
        }
    }
}
